import styled from 'styled-components/macro';
import modularScale from 'styles/helpers/modular-scale';
import Button from 'components/elements/button';
import {
  space,
  compose,

  // types
  SpaceProps,
} from 'styled-system';
import Box from 'components/elements/Box';

export const Meta = styled('p')`
  line-height: 1.2;
  color: ${({ theme }): string => theme.CasperGrey};
  font-size: ${modularScale(-1)};
`;

type InputProps = SpaceProps;

export const Input = styled.input<InputProps>`
  ${compose(space)}
  border: 2px solid transparent;
  padding: ${({ theme }): string => `${theme.spacing.medium}`};
  background: ${({ theme }): string => theme.Sand};
  color: black;
  color: ${({ theme }): string => `${theme.ShadowBlack}`};
  font-family: inherit;
  font-size: inherit;
  appearance: none;
  outline: none;
  box-sizing: border-box;
  width: 100%;
  &::placeholder {
    color: ${({ theme }): string => theme.CasperGrey};
    transition: ${({ theme }): string =>
      `color ${theme.transitionDuration} ${theme.timingFunction}`};
  }
  /* Change color on hover but not when focussed and hovered at the same time */
  &:hover:not(:focus)::placeholder {
    color: ${({ theme }): string => theme.DeepBlue};
  }
  &:invalid {
    border: ${({ theme }): string => `2px solid ${theme.NegativeChange}`};
  }
`;

export const RejectedMessage = styled('p')`
  color: ${({ theme }): string => theme.NegativeChange};
  margin: ${({ theme }): string => `${theme.spacing.small} 0 0`};
`;

export const ModalCloseButton = styled(Button)`
  & svg {
    transform: scale(1.8) translate(-6px, 8px);
    opacity: 0.4;
  }
`;

export const ListViewContentWrapper = styled(Box)`
  padding: 0 2.5rem;
`;
